/* Wo Lamhe – order value add-ons (product page) + cart drawer upsell + photo zoom */
(function () {
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function addonRoot(form) {
    var r = document.querySelector('[data-wl-addons]');
    if (!r) return null;
    // form.id can be shadowed by the <input name="id">, so read the attribute
    if (form && r.dataset.formId && r.dataset.formId !== form.getAttribute('id')) return null;
    return r;
  }


  /* ---------- Photo picker for the polaroid combo (data-wl-photos) ---------- */
  function shrinkPhoto(file) {
    return new Promise(function (resolve) {
      if (!/^image\//.test(file.type) || file.type === 'image/gif') return resolve(file);
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var s = Math.min(1, 2000 / Math.max(w, h));
        if (s === 1 && file.size < 1.5 * 1024 * 1024) { URL.revokeObjectURL(url); return resolve(file); }
        var c = document.createElement('canvas');
        c.width = Math.round(w * s); c.height = Math.round(h * s);
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (blob) {
          if (!blob) return resolve(file);
          resolve(new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  function pickerState(el) {
    if (!el._wlPhotos) el._wlPhotos = [];
    return el._wlPhotos;
  }

  function renderPicker(el) {
    var list = pickerState(el);
    var max = Number(el.dataset.max || 7);
    var grid = el.querySelector('[data-wl-photos-grid]');
    var count = el.querySelector('[data-wl-photos-count]');
    var btn = el.querySelector('[data-wl-photos-cta]');
    grid.innerHTML = '';
    list.forEach(function (p, i) {
      var d = document.createElement('div');
      d.className = 'wl-pp__item' + (p.ready ? '' : ' is-busy');
      d.innerHTML = '<img alt=""><button type="button" class="wl-pp__x" aria-label="Remove photo ' + (i + 1) + '">×</button>';
      d.querySelector('img').src = p.url;
      d.querySelector('button').addEventListener('click', function () {
        URL.revokeObjectURL(p.url);
        list.splice(list.indexOf(p), 1);
        renderPicker(el);
      });
      grid.appendChild(d);
    });
    if (count) count.textContent = list.length + ' / ' + max;
    if (btn) btn.textContent = list.length ? (list.length >= max ? 'All ' + max + ' photos added' : 'Add more photos') : 'Upload your ' + max + ' photos';
    el.classList.toggle('is-full', list.length >= max);
  }

  function addToPicker(el, files) {
    var list = pickerState(el);
    var max = Number(el.dataset.max || 7);
    Array.prototype.slice.call(files || []).forEach(function (f) {
      if (list.length >= max) return;
      if (!/^image\//.test(f.type) && !/\.(heic|heif|jpe?g|png|webp)$/i.test(f.name)) return;
      var p = { file: f, url: URL.createObjectURL(f), ready: false };
      list.push(p);
      shrinkPhoto(f).then(function (small) { p.file = small; p.ready = true; renderPicker(el); });
    });
    renderPicker(el);
  }

  window.WLPhotos = {
    // Ready files for a row (or null when the row has no picker)
    files: function (row) {
      var el = row && row.querySelector('[data-wl-photos]');
      if (!el) return null;
      return pickerState(el).filter(function (p) { return p.ready; }).map(function (p) { return p.file; });
    },
    busy: function (root) {
      var busy = false;
      (root || document).querySelectorAll('[data-wl-photos]').forEach(function (el) {
        if (pickerState(el).some(function (p) { return !p.ready; })) busy = true;
      });
      return busy;
    },
    // Adds one line item with its photos as a multipart request
    addItem: function (item, files) {
      var fd = new FormData();
      fd.append('id', item.id);
      fd.append('quantity', item.quantity || 1);
      var props = item.properties || {};
      Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
      if (files && files.length) {
        files.forEach(function (f, i) { fd.append('properties[Polaroid ' + (i + 1) + ']', f, f.name); });
      } else {
        fd.append('properties[Polaroid photos]', 'Sending on WhatsApp');
      }
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      }).then(function (res) { return res.json(); });
    },
    clear: function (root) {
      (root || document).querySelectorAll('[data-wl-photos]').forEach(function (el) {
        pickerState(el).forEach(function (p) { URL.revokeObjectURL(p.url); });
        el._wlPhotos = [];
        renderPicker(el);
      });
    },
  };

  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('[data-wl-photos] input[type=file]')) return;
    addToPicker(inp.closest('[data-wl-photos]'), inp.files);
    inp.value = '';
  });

  window.WLAddons = {
    added: [],

    collect: function (form) {
      var r = addonRoot(form);
      if (!r) return [];
      var items = [];
      r.querySelectorAll('.wl-addon.is-on').forEach(function (row) {
        var id = row.dataset.variant;
        var sel = row.querySelector('select');
        if (sel) id = sel.value;
        if (!id) return;
        var item = { id: Number(id), quantity: 1 };
        var note = row.querySelector('textarea');
        if (note && note.value.trim()) item.properties = { 'Letter message': note.value.trim() };
        var photos = window.WLPhotos.files(row);
        if (photos) item._photos = photos;
        items.push(item);
      });
      return items;
    },

    addSelected: function (form) {
      var self = this;
      self.added = [];
      var items = self.collect(form);
      if (!items.length) return Promise.resolve();
      var withPhotos = items.filter(function (i) { return i._photos; });
      var plain = items.filter(function (i) { return !i._photos; });
      function track(i) { self.added.push({ key: i.key, quantity: Math.max(i.quantity - 1, 0) }); }
      var chain = withPhotos.reduce(function (p, it) {
        return p.then(function () {
          return window.WLPhotos.addItem(it, it._photos).then(function (d) { if (d && d.key) track(d); });
        });
      }, Promise.resolve());
      if (!plain.length) return chain;
      return chain.then(function () {
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: plain }),
        })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (data) {
            if (data && data.items) data.items.forEach(track);
          });
      });
    },

    rollback: function () {
      var list = this.added || [];
      this.added = [];
      return list.reduce(function (p, a) {
        return p.then(function () {
          return fetch(window.routes.cart_change_url + '.js', {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ id: a.key, quantity: a.quantity }),
          });
        });
      }, Promise.resolve());
    },

    reset: function (form) {
      this.added = [];
      var r = addonRoot(form);
      if (!r) return;
      r.querySelectorAll('.wl-addon').forEach(function (row) {
        row.classList.remove('is-on');
        var cb = row.querySelector('input[type=checkbox]');
        if (cb) cb.checked = false;
        var t = row.querySelector('textarea');
        if (t) t.value = '';
      });
      window.WLPhotos.clear(r);
    },
  };


  /* Don't add to cart while combo photos are still being prepared */
  document.addEventListener('submit', function (e) {
    var r = addonRoot(e.target);
    if (!r || !window.WLPhotos.busy(r)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var el = r.querySelector('[data-wl-photos]');
    var note = el && el.querySelector('.wl-pp__note');
    if (note) note.textContent = 'Your photos are still being prepared — tap Add to cart again in a moment.';
  }, true);


  /* Festival helpers: hide [data-wl-until] after its date, count down [data-wl-cutoff] (India time) */
  function todayIST() {
    try { return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' }); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function daysBetween(a, b) {
    return Math.round((Date.parse(b + 'T00:00:00Z') - Date.parse(a + 'T00:00:00Z')) / 86400000);
  }
  function festival(root) {
    var t = todayIST();
    (root || document).querySelectorAll('[data-wl-until]').forEach(function (el) {
      if (t > el.dataset.wlUntil) el.hidden = true;
    });
    (root || document).querySelectorAll('[data-wl-cutoff]').forEach(function (el) {
      var d = daysBetween(t, el.dataset.wlCutoff);
      var left = el.querySelector('[data-wl-left]');
      el.classList.toggle('is-past', d < 0);
      if (!left) return;
      left.textContent = d < 0 ? 'Missed it? Pick Priority' : d === 0 ? 'Last day today!' : d === 1 ? '1 day left' : d + ' days left';
    });
  }
  window.WLFestival = festival;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { festival(); });
  else festival();

  /* "When do you need it?" box: works out the dispatch date (working days, Sundays off) */
  var NEED_STD = 8, NEED_PRIO = 7, NEED_TRANSIT = 6;
  function addDays(iso, n) {
    var d = new Date(iso + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }
  function isSunday(iso) { return new Date(iso + 'T00:00:00Z').getUTCDay() === 0; }
  function addWorking(iso, n) {
    var step = n < 0 ? -1 : 1, left = Math.abs(n), d = iso;
    while (left > 0) { d = addDays(d, step); if (!isSunday(d)) left--; }
    return d;
  }
  function workingBetween(a, b) {
    var n = 0, d = a;
    while (d < b) { d = addDays(d, 1); if (!isSunday(d)) n++; }
    return n;
  }
  function niceDate(iso) {
    var d = new Date(iso + 'T00:00:00Z');
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  }
  function needScope(box) {
    return box.closest('[data-wl-builder]') || box.closest('.wl-addons') || document;
  }
  function needPrioOn(box) {
    var scope = needScope(box);
    var cb = scope.querySelector('[data-wl-prio] input[type=checkbox]');
    if (cb) return cb.checked;
    var all = scope.querySelectorAll('.wl-b__radio:checked');
    for (var i = 0; i < all.length; i++) if (/priority/i.test(all[i].value)) return true;
    return false;
  }
  function needPrioPrice(box) {
    var scope = needScope(box);
    var p = scope.querySelector('.wl-prio__price');
    if (p) return p.textContent.trim();
    var radios = scope.querySelectorAll('.wl-b__radio');
    for (var i = 0; i < radios.length; i++) {
      if (/priority/i.test(radios[i].value)) {
        var lab = scope.querySelector('label[for="' + radios[i].id + '"] .wl-b__pill-p');
        if (lab) return lab.textContent.trim();
      }
    }
    return '';
  }
  function needPickPrio(box) {
    var scope = needScope(box);
    var cb = scope.querySelector('[data-wl-prio] input[type=checkbox]');
    if (cb) { if (!cb.checked) cb.click(); return; }
    var radios = scope.querySelectorAll('.wl-b__radio');
    for (var i = 0; i < radios.length; i++) {
      if (/priority/i.test(radios[i].value) && !radios[i].disabled) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }
  function needRender(box) {
    var input = box.querySelector('[data-wl-need-date]');
    var msg = box.querySelector('[data-wl-need-msg]');
    var outNeed = box.querySelector('[data-wl-need-out=need]');
    var outShip = box.querySelector('[data-wl-need-out=ship]');
    var t = todayIST();
    input.min = addDays(t, 1);
    var v = input.value;
    box.classList.remove('is-ok', 'is-rush');
    if (!v || v < input.min) {
      outNeed.disabled = outShip.disabled = true;
      box.dataset.need = box.dataset.ship = '';
      msg.hidden = true;
      return;
    }
    var w = workingBetween(t, v);
    var prio = needPrioOn(box);
    var ship = addWorking(v, -NEED_TRANSIT);
    var soonest = addWorking(t, 1);
    if (ship < soonest) ship = soonest;
    var shipTxt = niceDate(ship) + (w < NEED_STD ? ' (URGENT)' : '') + (prio ? ' · Priority' : '');
    outNeed.value = niceDate(v);
    outShip.value = shipTxt;
    outNeed.disabled = outShip.disabled = false;
    box.dataset.need = outNeed.value;
    box.dataset.ship = shipTxt;
    var html;
    if (w >= NEED_STD) {
      box.classList.add('is-ok');
      html = '✓ <strong>On time.</strong> Send your photos today and it reaches you by ' + niceDate(v) + '.';
    } else if (w >= NEED_PRIO) {
      box.classList.add('is-ok');
      if (prio) {
        html = '✓ <strong>On time with Priority.</strong> Send your photos today.';
      } else {
        var price = needPrioPrice(box);
        html = '✓ <strong>We can make it by ' + niceDate(v) + '.</strong> Want extra peace of mind? ' +
          '<button type="button" class="wl-need__link" data-wl-need-prio>Priority' + (price ? ' (' + price + ')' : '') + '</button> dispatches next day.';
      }
    } else {
      box.classList.add('is-rush');
      html = '📦 <strong>Rush order noted</strong> — we\'ll put yours first in line. Send your photos on WhatsApp (95308 56380) right after ordering so we can start today.';
    }
    msg.innerHTML = html;
    msg.hidden = false;
  }
  function needAll() {
    document.querySelectorAll('[data-wl-needby]').forEach(needRender);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var box = t.closest('[data-wl-needby]');
    if (box) { needRender(box); return; }
    if (t.closest('[data-wl-prio]') || (t.classList && t.classList.contains('wl-b__radio'))) setTimeout(needAll, 0);
  });
  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-wl-needby]');
    if (box) needRender(box);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wl-need-prio]');
    if (!b) return;
    var box = b.closest('[data-wl-needby]');
    needPickPrio(box);
    setTimeout(needAll, 50);
  });
  window.WLNeedBy = { render: needAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', needAll);
  else needAll();

  /* Live "Your total" (main product x qty + ticked extras) */
  function wlInr(c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }
  function wlTotal() {
    var r = document.querySelector('[data-wl-addons]');
    if (!r) return;
    var box = r.querySelector('[data-wl-total]');
    var pj = r.querySelector('[data-wl-vprices]');
    if (!box || !pj) return;
    var prices; try { prices = JSON.parse(pj.textContent); } catch (e) { return; }
    var fid = r.dataset.formId;
    var form = fid && document.getElementById(fid);
    var idEl = form && form.querySelector('input[name="id"], select[name="id"]');
    if (!idEl || prices[idEl.value] == null) { box.hidden = true; return; }
    var qEl = document.querySelector('input[name="quantity"][form="' + fid + '"]') || (form && form.querySelector('input[name="quantity"]'));
    var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    var main = prices[idEl.value] * qty, extras = 0;
    r.querySelectorAll('.wl-addon.is-on').forEach(function (row) {
      var sel = row.querySelector('select');
      var c = sel && sel.selectedOptions[0] ? sel.selectedOptions[0].dataset.cents : row.dataset.cents;
      extras += Number(c || 0);
    });
    var sum = main + extras;
    box.querySelector('[data-wl-t-main]').textContent = wlInr(main);
    box.querySelector('[data-wl-t-xrow]').hidden = !extras;
    box.querySelector('[data-wl-t-extras]').textContent = '+' + wlInr(extras);
    box.querySelector('[data-wl-t-sum]').textContent = wlInr(sum);
    box.querySelector('[data-wl-t-ship]').textContent = sum >= 99900 ? '🎉 Free express delivery unlocked' : 'Add ' + wlInr(99900 - sum) + ' more for free express delivery';
    box.hidden = false;
    var btn = form.querySelector('[type="submit"][name="add"] > span');
    if (btn && !form.querySelector('[type="submit"][name="add"]').disabled) btn.textContent = (window.variantStrings && window.variantStrings.addToCart || 'Add to cart') + (extras ? ' · ' + wlInr(sum) : '');
  }
  window.WLTotal = wlTotal;
  function wlTotalSoon() { setTimeout(wlTotal, 0); setTimeout(wlTotal, 450); }
  document.addEventListener('change', wlTotalSoon);
  document.addEventListener('input', function (e) { if (e.target.name === 'quantity') wlTotalSoon(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.quantity__button')) wlTotalSoon(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wlTotal); else wlTotal();

  /* Swap the row photo + price when a different design is picked */
  function syncThumb(sel) {
    var row = sel.closest('.wl-addon, [data-wlb-addon]');
    var o = sel.selectedOptions && sel.selectedOptions[0];
    if (!row || !o) return;
    var btn = row.querySelector('[data-wl-zoom]');
    var img = btn && btn.querySelector('img');
    if (img && o.dataset.img) {
      img.removeAttribute('srcset');
      img.src = o.dataset.img;
    }
    if (btn && o.dataset.zoom) btn.dataset.wlZoom = o.dataset.zoom;
    var now = row.querySelector('.wl-addon__price [data-now]');
    var was = row.querySelector('.wl-addon__price [data-was]');
    if (now && o.dataset.now) now.textContent = o.dataset.now;
    if (was && o.dataset.was) was.textContent = o.dataset.was;
  }

  /* "Need it early?" tick box drives the hidden Priority option */
  function setPriority(box, on) {
    var picker = document.getElementById(box.dataset.target);
    if (!picker) return;
    var want = on ? box.dataset.yes : box.dataset.no;
    var inputs = picker.querySelectorAll('input[type=radio]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === want) {
        if (!inputs[i].checked) inputs[i].click();
        return;
      }
    }
    var sel = picker.querySelectorAll('select');
    for (var j = 0; j < sel.length; j++) {
      for (var k = 0; k < sel[j].options.length; k++) {
        if (sel[j].options[k].value === want) {
          sel[j].selectedIndex = k;
          sel[j].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var prio = t.closest('[data-wl-prio]');
    if (prio && t.type === 'checkbox') {
      prio.classList.toggle('is-on', t.checked);
      setPriority(prio, t.checked);
      return;
    }
    var cb = t.closest('.wl-addon input[type=checkbox]');
    if (cb) cb.closest('.wl-addon').classList.toggle('is-on', cb.checked);
    if (t.matches('select[data-wl-thumb-select], select[data-variant-select]')) syncThumb(t);
  });

  /* Tap a small photo to see it big */
  var zoom = null;
  function openZoom(src, alt) {
    if (!zoom) {
      zoom = document.createElement('dialog');
      zoom.className = 'wl-zoom';
      zoom.innerHTML = '<button type="button" class="wl-zoom__close" aria-label="Close">×</button><img alt="">';
      zoom.addEventListener('click', function (e) {
        if (e.target === zoom || e.target.closest('.wl-zoom__close')) zoom.close();
      });
      document.body.appendChild(zoom);
    }
    var img = zoom.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    if (zoom.showModal) zoom.showModal();
    else zoom.setAttribute('open', '');
  }

  document.addEventListener('click', function (e) {
    var z = e.target.closest ? e.target.closest('[data-wl-zoom]') : null;
    if (!z) return;
    e.preventDefault();
    openZoom(z.dataset.wlZoom, z.getAttribute('aria-label'));
  });

  /* One-tap add from the cart drawer */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wl-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var one = { id: Number(btn.dataset.wlAdd), quantity: 1 };
    if (btn.dataset.wlProps) { try { one.properties = JSON.parse(btn.dataset.wlProps); } catch (err) {} }
    var body = { items: [one] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }
    fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status) {
          btn.textContent = 'Unavailable';
          return;
        }
        if (drawer && data.sections) drawer.renderContents(data);
        else window.location.reload();
      })
      .catch(function (err) {
        console.error(err);
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  /* Inject free-delivery bar + "Complete the gift" into the cart drawer */
  var inflight = false;
  var timer = null;

  function inject() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var inner = d.querySelector('.drawer__inner');
    if (!inner || inner.querySelector('.drawer__inner-empty')) return;
    if (inner.querySelector('[data-wl-injected]') || inflight) return;
    inflight = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=wl-cart-upsell')
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bar = doc.querySelector('[data-wl-part="bar"]');
        var gift = doc.querySelector('[data-wl-part="gift"]');
        var cur = document.querySelector('cart-drawer .drawer__inner');
        if (!cur || cur.querySelector('[data-wl-injected]') || cur.querySelector('.drawer__inner-empty')) return;
        var header = cur.querySelector('.drawer__header');
        if (bar && header) {
          bar.setAttribute('data-wl-injected', '');
          header.after(bar);
        }
        var footer = cur.querySelector('.drawer__footer');
        if (gift && footer) {
          gift.setAttribute('data-wl-injected', '');
          footer.prepend(gift);
        }
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        inflight = false;
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(inject, 60);
  }

  function start() {
    schedule();
    var d = document.querySelector('cart-drawer');
    if (d) new MutationObserver(schedule).observe(d, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
